function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import { actions as notificationActions } from '../../../reducers/notification.reducer';
import { actions as modalActions } from '../../../reducers/modal.reducer';
import { actions as cmsActions } from '../../../reducers/cms.reducer';
import { blurObj, lowResObj } from '../../../helpers/assets';
import ModalHeader from '../../modal/ModalHeader.react';
import Button from '../../common/Button.react';
var ReuploadImage = function ReuploadImage(_ref) {
  var assetID = _ref._id,
    _ref$type = _ref.type,
    pType = _ref$type === void 0 ? 'image' : _ref$type,
    _ref$onUploaded = _ref.onUploaded,
    onUploaded = _ref$onUploaded === void 0 ? null : _ref$onUploaded;
  var _useState = useState(uuid()),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  var dispatch = useDispatch();
  var endpoint = useSelector(function (s) {
    return s.config.endpoints.cms.assets;
  });
  var _useState3 = useState({
      type: pType,
      file: null,
      asset: null,
      loading: false
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    form = _useState4[0],
    setForm = _useState4[1];
  var file = form.file,
    asset = form.asset,
    loading = form.loading,
    type = form.type;
  var onChangeHandler = function onChangeHandler(e) {
    setForm(_objectSpread(_objectSpread({}, form), {}, {
      file: e.target.files[0]
    }));
  };
  var onClickHandler = function onClickHandler() {
    var data = new FormData();
    data.append('assetID', assetID);
    data.append('original', file);
    data.append('blur', blurObj[type]);
    data.append('lowRes', lowResObj[type]);
    setForm(_objectSpread(_objectSpread({}, form), {}, {
      loading: true
    }));
    axios.put("".concat(endpoint, "/replace"), data, {}).then(function (res) {
      dispatch({
        type: cmsActions.setAssets,
        payload: res.data.assets
      });
      if (onUploaded) onUploaded(res.data.assets[Object.keys(res.data.assets)]);
      dispatch({
        type: notificationActions.addToast,
        payload: {
          message: 'File uploaded successfully!'
        }
      });
      setForm(_objectSpread(_objectSpread({}, form), {}, {
        loading: false
      }));
      dispatch({
        type: modalActions.remove
      });
    }).catch(function (err) {
      var data = err.response.data;
      var toastArr = Object.values(data.toast);
      for (var i = 0; i < toastArr.length; i++) dispatch({
        type: notificationActions.addToast,
        payload: toastArr[i]
      });
      setForm(_objectSpread(_objectSpread({}, form), {}, {
        loading: false
      }));
    });
  };
  var isValid = function isValid() {
    return file !== null && !loading;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "modal"
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    title: asset ? 'Image Uploaded' : 'Replace Image'
  }), /*#__PURE__*/React.createElement("div", {
    className: "modal__body upload-image"
  }, !file && /*#__PURE__*/React.createElement(Button, {
    label: "Select Image",
    onClick: function onClick() {
      $("#".concat(id)).click();
    },
    style: {
      width: '100%',
      marginBottom: 15
    }
  }), file && /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      onClickHandler();
    },
    label: "Upload",
    disabled: !isValid(),
    style: {
      width: '100%',
      marginBottom: 15
    }
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      dispatch({
        type: modalActions.remove
      });
    },
    label: "Close",
    type: "cancel",
    disabled: loading,
    style: {
      width: '100%'
    }
  }), /*#__PURE__*/React.createElement("input", {
    type: "file",
    id: id,
    onChange: function onChange(e) {
      return onChangeHandler(e);
    },
    accept: "image/*",
    className: "hidden"
  })));
};
export default ReuploadImage;